module.exports = __webpack_public_path__ + "static/media/0f8a8546-b0af-49da-8eb4-699eb8f1e880_1.16ac6997c14f310add0b08c2c18773ce.3e4be836.jpeg";